export default "__VITE_ASSET__BfroDKpy__"